import Vue from 'vue'
import Vuex from 'vuex'
import { procedure } from './Procedure/index'
import { auction } from './Auction/index'
import { auctionb } from './AuctionB/index'
import { account } from './Account/index'
import createPersistedState from 'vuex-persistedstate'
import { RootState } from './RootState'

Vue.use(Vuex)

const store = {
  state: {
    version: '1.0.0'
  },
  modules: {
    procedure,
    auction,
    auctionb,
    account
  },
  plugins: [
    createPersistedState({
      paths: [
        'procedure',
        'account',
        'auction',
        'auctionb'
      ],
      storage: window.sessionStorage
    })
  ]
}

export default new Vuex.Store<RootState>(store)
